import AppRoutes from "../routing/app-routes";
import { setFooter, setHeader, showHeader } from "../globals/layout-config";
import { useLocation } from "react-router-dom";
import { route } from "../globals/constants";

function RootLayout({
    layoutInfo,
    breadcrumbList,
    topmenuList
}) {
    const currentpath = useLocation().pathname;

    const isFooterFixed = () => {
        return currentpath === route.pages.features.footer.FIXED
    }

    return (
        <>
            {
                isFooterFixed()
                    ? <FixedFooterLayout 
                        currentpath={currentpath}
                        layoutInfo={layoutInfo}
                        breadcrumbList={breadcrumbList}
                        topmenuList={topmenuList}
                        />
                    : <AppLayout 
                        currentpath={currentpath} 
                        layoutInfo={layoutInfo}
                        breadcrumbList={breadcrumbList}
                        topmenuList={topmenuList}
                        />
            }
        </>
    )
}

function FixedFooterLayout(props) {
    const { currentpath,layoutInfo,topmenuList } = props;
    return (
        <>
            <div className="footer-fixed">
                <AppLayout 
                    currentpath={currentpath} 
                    layoutInfo={layoutInfo}
                    topmenuList={topmenuList}
                    />
            </div>
        </>
    )
}

function AppLayout(props) {
    const { currentpath, layoutInfo,breadcrumbList,topmenuList } = props;

    return (
        <>
            <div className="page-wraper">
            
                {/* HEADER START */}
                {
                    showHeader(currentpath) &&
                    setHeader(currentpath, layoutInfo, topmenuList)
                }

                {/* Content Mid part*/}
                <div className="page-content">
                    <AppRoutes layoutInfo={layoutInfo} breadcrumbList={breadcrumbList}/>
                </div>

                {/* Footer Part*/}
                {
                    setFooter(currentpath,layoutInfo)
                }

                {/* Scroll Top Button */}
                <button className="scroltop"><span className="fa fa-space-shuttle relative" id="btn-vibrate" /></button>
            </div>
        </>
    )
}


export default RootLayout;